export const ACTION_GET_PAST_ORDERS = '/OrderLines/GetPastOrders';
// export const ACTION_GET_PAST_ORDERS = '/OrderLines/GetVisitorOrder?orderId=Entity-Order-25391a40f6624243a96be7e4d3fd67aa';

